export default function FinanceRequestIcon() {
  return (
    <svg width="101" height="101" viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M65.5225 55.3555H56.4808C49.0641 55.3555 43.0225 49.3555 43.0225 41.8971V32.8555C43.0225 31.1471 41.6475 29.7305 39.8975 29.7305H26.6891C17.0641 29.7305 9.27246 35.9805 9.27246 47.1471V74.8138C9.27246 85.9805 17.0641 92.2305 26.6891 92.2305H51.2308C60.8558 92.2305 68.6475 85.9805 68.6475 74.8138V58.4805C68.6475 56.7305 67.2308 55.3555 65.5225 55.3555Z"
        fill="url(#paint0_linear_13792_12213)"
      />
      <path
        d="M75.1891 8.89453H66.9808H62.4391H50.6475C41.2308 8.89453 33.6058 14.8945 33.2725 25.6029C33.5225 25.6029 33.7308 25.5612 33.9808 25.5612H45.7725H50.3141H58.5225C68.1475 25.5612 75.9391 31.8112 75.9391 42.9779V51.1862V62.4779V70.6862C75.9391 70.9362 75.8975 71.1445 75.8975 71.3529C85.1891 71.0612 92.6058 64.8945 92.6058 54.0195V45.8112V34.5195V26.3112C92.6058 15.1445 84.8141 8.89453 75.1891 8.89453Z"
        fill="url(#paint1_linear_13792_12213)"
      />
      <path
        d="M50.8564 30.3541C49.5648 29.0624 47.3564 29.9374 47.3564 31.7291V42.6458C47.3564 47.2291 51.2314 50.9791 55.9814 50.9791C58.9398 51.0208 63.0648 51.0208 66.6064 51.0208C68.3981 51.0208 69.3148 48.9374 68.0648 47.6874C63.5231 43.1458 55.4398 35.0208 50.8564 30.3541Z"
        fill="url(#paint2_linear_13792_12213)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13792_12213"
          x1="62.718"
          y1="60.9801"
          x2="16.0273"
          y2="59.1186"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0BAAA1" />
          <stop offset="1" stopColor="#0B8DAA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13792_12213"
          x1="86.6805"
          y1="40.1234"
          x2="40.0226"
          y2="38.2632"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0BAAA1" />
          <stop offset="1" stopColor="#0B8DAA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_13792_12213"
          x1="66.5159"
          y1="40.3794"
          x2="49.7808"
          y2="39.677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0BAAA1" />
          <stop offset="1" stopColor="#0B8DAA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
